import { createSelector } from 'reselect'
import * as R from 'ramda'

import {
  createSelectorWithPath,
  createSelectorWithEntity,
} from 'helpers/ComponentSelectorUtil'
import { getMonthDayYear } from 'helpers/DateUtil'
import {
  getUiPath,
} from 'containers/Form/util'

const valuesSelectorFunc = state => state.values
const inputTextSelectorFunc = state => state.inputText
const getValuesSelector = (id) => createSelectorWithPath(
  getUiPath(id),
  R.compose(
    R.filter(R.complement(R.isEmpty)),
    R.values,
    inputTextSelectorFunc
  )
)

const formatDatesSelectorHoc = (valuesSelector) => (
  createSelector(
    valuesSelector,
    (values) => {
      const formatDates = {}
      values.forEach(value => {
        formatDates[value.scheduleType] = value.startDate ? new Date(value.startDate) : null
      })

      return formatDates
    }
  )
)

const dateIntsSelectorHoc = (formatDatesSelector) => (
  createSelector(
    formatDatesSelector,
    (formatDates) => {
      const dateInts = {...formatDates}

      for (const label in formatDates) {
        if (formatDates.hasOwnProperty(label)) {
          dateInts[label] = formatDates[label] ? getMonthDayYear(formatDates[label]).replace(/\//g, '') : ''
        }
      }

      return dateInts
    }
  )
)

export {
  getValuesSelector,
}
export default (valuePath, uiPath) => {
  const withPath = createSelectorWithPath(valuePath)
  const withUiPath = createSelectorWithPath(uiPath)

  const valuesSelector = withPath(valuesSelectorFunc)
  const formatDatesSelector = formatDatesSelectorHoc(valuesSelector)
  const dateIntsSelector = dateIntsSelectorHoc(formatDatesSelector)

  const inputTextSelector = withUiPath(inputTextSelectorFunc)

  return {
    valuesSelector,
    formatDatesSelector,
    dateIntsSelector,
    inputTextSelector,
  }
}
